import { Dispatch, ReactNode } from 'react';

import { ChakraBox, ChakraFlex } from '@equip.health/ui';
import type { AssessmentAction } from '~/lib/constants/patients.constants';
import { ErrorBoundary } from 'react-error-boundary';

import { TreatmentOverviewCard } from '~/components/common/TreatmentOverviewCard';
import { TreatmentOverviewCardErrorFallback } from '~/components/common/TreatmentOverviewCard/TreatmentOverviewCardErrorFallback';
import CareTeamErrorFallback from '~/components/maud/patients/profile/tabs/careplan/care-team-v2/CareTeamErrorFallback';
import CareTeamV2 from '~/components/maud/patients/profile/tabs/careplan/care-team-v2';
import CarePlanningSubTabs from './CarePlanningSubTabs';

interface PatientCarePlanTabProps {
  children?: ReactNode;
  detailsTabId?: string;
  patientId: string;
  updateAssessmentState: Dispatch<AssessmentAction>;
}

export const PatientCarePlanTab = ({
  children,
  patientId,
  updateAssessmentState,
  detailsTabId,
}: PatientCarePlanTabProps) => {
  return (
    <ChakraFlex align="start" gap="40px">
      <ChakraFlex flexDirection="column">
        <ErrorBoundary fallback={<TreatmentOverviewCardErrorFallback />}>
          <TreatmentOverviewCard
            patientId={patientId}
            updateAssessmentState={updateAssessmentState}
          />
        </ErrorBoundary>
        <ErrorBoundary fallback={<CareTeamErrorFallback />}>
          <ChakraBox marginX="16px">
            <CareTeamV2 patientId={patientId} />
          </ChakraBox>
        </ErrorBoundary>
      </ChakraFlex>
      {children ? (
        <ChakraFlex direction="column" width="100%">
          {children}
        </ChakraFlex>
      ) : (
        <CarePlanningSubTabs patientId={patientId} detailsTabId={detailsTabId} />
      )}
    </ChakraFlex>
  );
};
